export default __webpack_public_path__ + "static/lead-pc-6a93588343afb37226312f389895fb06.svg";